import type { ChipProps } from '@mui/material/Chip';
import type { FunctionComponent, MouseEventHandler } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import type { ChipPropType } from '../../../design/components/skillChips/SkillChip';
import { SkillChip } from '../../../design/components/skillChips/SkillChip';

type SkillChipWithDrawerProps = Pick<ChipProps, 'size' | 'variant'> & {
    readonly isDisabled?: boolean | undefined;
    readonly isSynced?: boolean | undefined;
    readonly label: string;
    readonly showAddIcon?: boolean;
    readonly skillId: string;
    readonly type?: ChipPropType;
};

export const SkillChipWithDrawer: FunctionComponent<SkillChipWithDrawerProps> = (props) => {
    const { actions } = useContext(ApplicationContext);

    const handleClick: MouseEventHandler = (e): void => {
        e.preventDefault();
        e.stopPropagation();

        actions.openSkillDetails(props.skillId);
    };

    return <SkillChip isSynced={props.isSynced} {...props} onClick={handleClick} />;
};
